import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc CmsWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CmsWidgetService } from 'services/cmsWidget';
 *
 * // create service instance and send/cancel request
 * const cmsWidgetService = new CmsWidgetService();
 * const result = await cmsWidgetService.fetchData( '<user-id>' ); // fetch data
 * cmsWidgetService.cancel(); // cancel an active request
 */
export class CmsWidgetService extends HttpService {

    // make request and fetch component data
    async fetchCategoryWidgetData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: {
                    data: get( response, 'body.component.data', {} ),
                    ...get( response, 'body.component.structure', {} )
                }
            };
            
        } catch( errResponse ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

    // submit form data
    async submitFormData( { url = {}, data = {} } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    data: get( response, 'body.component.data', {} ),
                    ...get( response, 'body.component.structure', {} )
                }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
}
